import useScrollToTop from 'frontcore/utils/useScrollToTop'
import { createRouter, createWebHistory } from 'vue-router'
import { DASHBOARD_MODULE_TOKENS } from 'frontend/constants/settings'
import type { RouteLocation } from 'vue-router'

const { scrollToTop } = useScrollToTop()

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: DASHBOARD_MODULE_TOKENS.home.name,
      components: {
        default: () => import('frontend/pages/home/HomePage.vue'),
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: DASHBOARD_MODULE_TOKENS.pageNotFound.name,
      components: {
        default: () => import('frontcore/components/PageNotFound.vue'),
      },
    },
  ],
  scrollBehavior (to) {
    if (to.hash) {
      return { el: to.hash }
    }
    const shouldKeepScroll = to.meta?.keepScroll ?? false
    if (shouldKeepScroll) { return }
    setTimeout(scrollToTop, 200)
  },
})

router.beforeEach((to, from, next) => {
  if (!routeHasQueryParams(to) && routeHasQueryParams(from) && to.path === from.path) {
    next({ path: to.path, query: from.query, replace: true })
  } else {
    next()
  }
})

const routeHasQueryParams = (route: RouteLocation): boolean => {
  return Object.keys(route.query).length > 0 && !Object.entries(route.query).every(([_, filter_value]) => filter_value === undefined)
}

export default router
